import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {CitizensServicesDeliveryProcedureDiagram} from './citizens-services-delivery-procedure-diagram.model';

export const loadCitizensServicesDeliveryProcedureDiagrams = createAction(
  '[CitizensServicesDeliveryProcedureDiagram/API] Load CitizensServicesDeliveryProcedureDiagrams',
  props<{ citizensServicesDeliveryProcedureDiagrams: CitizensServicesDeliveryProcedureDiagram[] }>()
);

export const addCitizensServicesDeliveryProcedureDiagram = createAction(
  '[CitizensServicesDeliveryProcedureDiagram/API] Add CitizensServicesDeliveryProcedureDiagram',
  props<{ citizensServicesDeliveryProcedureDiagram: CitizensServicesDeliveryProcedureDiagram }>()
);

export const upsertCitizensServicesDeliveryProcedureDiagram = createAction(
  '[CitizensServicesDeliveryProcedureDiagram/API] Upsert CitizensServicesDeliveryProcedureDiagram',
  props<{ citizensServicesDeliveryProcedureDiagram: CitizensServicesDeliveryProcedureDiagram }>()
);

export const addCitizensServicesDeliveryProcedureDiagrams = createAction(
  '[CitizensServicesDeliveryProcedureDiagram/API] Add CitizensServicesDeliveryProcedureDiagrams',
  props<{ citizensServicesDeliveryProcedureDiagrams: CitizensServicesDeliveryProcedureDiagram[] }>()
);

export const upsertCitizensServicesDeliveryProcedureDiagrams = createAction(
  '[CitizensServicesDeliveryProcedureDiagram/API] Upsert CitizensServicesDeliveryProcedureDiagrams',
  props<{ citizensServicesDeliveryProcedureDiagrams: CitizensServicesDeliveryProcedureDiagram[] }>()
);

export const updateCitizensServicesDeliveryProcedureDiagram = createAction(
  '[CitizensServicesDeliveryProcedureDiagram/API] Update CitizensServicesDeliveryProcedureDiagram',
  props<{ citizensServicesDeliveryProcedureDiagram: Update<CitizensServicesDeliveryProcedureDiagram> }>()
);

export const updateCitizensServicesDeliveryProcedureDiagrams = createAction(
  '[CitizensServicesDeliveryProcedureDiagram/API] Update CitizensServicesDeliveryProcedureDiagrams',
  props<{ citizensServicesDeliveryProcedureDiagrams: Update<CitizensServicesDeliveryProcedureDiagram>[] }>()
);

export const deleteCitizensServicesDeliveryProcedureDiagram = createAction(
  '[CitizensServicesDeliveryProcedureDiagram/API] Delete CitizensServicesDeliveryProcedureDiagram',
  props<{ id: string }>()
);

export const deleteCitizensServicesDeliveryProcedureDiagrams = createAction(
  '[CitizensServicesDeliveryProcedureDiagram/API] Delete CitizensServicesDeliveryProcedureDiagrams',
  props<{ ids: string[] }>()
);

export const clearCitizensServicesDeliveryProcedureDiagrams = createAction(
  '[CitizensServicesDeliveryProcedureDiagram/API] Clear CitizensServicesDeliveryProcedureDiagrams'
);


//custom

export const citizenGetServicesDeliveryProcedureDiagram = createAction(
  '[CitizensServicesDeliveryProcedureDiagram/API] citizen Get Services Delivery Procedure Diagram',
  props<{ serviceUniqueId: string }>()
);
